




import { computed, defineComponent, watch } from "@vue/composition-api";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import WaitingPaymentModal from "./WaitingPaymentModal";

export default defineComponent({
  name: "DefaultPaymentComponent",
  components: { WaitingPaymentModal },
  props: {
    show: { type: Boolean, required: true },
    purchaseSubject: { type: Object as () => Subject<PurchaseSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    const show = computed(() => props.show);
    useBeforeUnloadTab(show);

    watch(
      show,
      show => {
        if (show) {
          emit("submit", { purchaseSubject: props.purchaseSubject });
          emit("setCloseOnError", true);
        }
      },
      { immediate: true }
    );
  },
});
